import { AfterViewInit, Component, Inject, Injectable, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { ModalInterface } from "app/interface/modal";
import { BehaviorSubject } from 'rxjs';
import moment, { isMoment, Moment } from 'moment';
import { NxDatepickerIntl, NxDateAdapter, NX_DATE_LOCALE } from '@aposin/ng-aquila/datefield';
import { LocaleService } from '@core/services/locale.service';
import { TravelMemberService } from '@core/services/travel-member.service';
import { InsuredTripSummary } from '@shared/models/policies/detail/insured-trip/insured-trip-summary';
import { CommonService } from '@core/services/common.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MyIntl extends NxDatepickerIntl {
    constructor(private translateService: TranslateService) {
        super();
        this.switchToMonthViewLabel = this.translateService.instant('common.date.month-view');
        this.switchToMultiYearViewLabel = this.translateService.instant('common.date.date-view');
    }
}

@Component({
    selector: 'app-generate-report',
    templateUrl: './generate-report.component.html',
    styleUrls: ['./generate-report.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class GenerateReportComponent implements AfterViewInit, ModalInterface, OnInit {
    // interface
    @ViewChild('GenerateReport') modalTemplateRef: TemplateRef<any>;
    initiator: BehaviorSubject<boolean> = new BehaviorSubject(false);
    modalDialogRef: NxModalRef<any>;
    confirm: BehaviorSubject<SubmitEvent> = new BehaviorSubject(null);

    // component
    formGenerateReport: FormGroup;
    private policyNumber: string;

    constructor(
        private commonService: CommonService,
        protected dialogService: NxDialogService,
        private localeService: LocaleService,
        public dateAdapter: NxDateAdapter<Moment>,
        private travelMemberService: TravelMemberService,
        private translateService: TranslateService,
        @Inject(NX_DATE_LOCALE) private nxDateLocale: string,
        @Inject(NxDatepickerIntl) private intl: NxDatepickerIntl,
    ) { 

        this.translateService.get('common.date.month-view').subscribe( x => {
            this.intl.switchToMonthViewLabel = x;
        })

        this.translateService.get('common.date.date-view').subscribe( x => {
            this.intl.switchToMultiYearViewLabel = x;
        })

        translateService.onLangChange.subscribe(x => {
            let lang = this.localeService.languages.find(y => y.code.toLowerCase() == x.lang);
            if (lang && lang.iso) {
                intl.switchToMonthViewLabel = translateService.instant('common.date.month-view');
                intl.switchToMultiYearViewLabel = translateService.instant('common.date.date-view');
                this.nxDateLocale = lang.iso;
            }
        });
    }



    ngOnInit(): void {
        this.formGenerateReport = new FormGroup({
            dateBegin: new FormControl('', Validators.required),
            dateEnd: new FormControl('', Validators.required)
        });

        this.localeService.activeLanguage.subscribe(language => {
            this.dateAdapter.setLocale(language.iso);
        });
    }

    ngAfterViewInit(): void {
        this.initiator.next(true);
    }

    openModal(): void {
        this.modalDialogRef = this.dialogService.open(this.modalTemplateRef, { showCloseIcon: true, width: '512px' });
    }

    closeModal(): void {
        this.modalDialogRef.close();
    }

    filterDateBegin = (date: Moment): boolean => {
        if (!isMoment(this.formGenerateReport.value.dateEnd) ||
            (isMoment(this.formGenerateReport.value.dateEnd) && date.isBefore(this.formGenerateReport.value.dateEnd))) {
            return true;
        }

        return false;
    }

    filterDateEnd = (date: Moment): boolean => {
        if (!isMoment(this.formGenerateReport.value.dateBegin) ||
            (isMoment(this.formGenerateReport.value.dateBegin) && date.isAfter(this.formGenerateReport.value.dateBegin))) {
            return true;
        }

        return false;
    }

    submitGenerateReport($event: SubmitEvent) {
        if (!this.formGenerateReport.valid) {
            return;
        }

        let insuredTripSummary = new InsuredTripSummary();
        insuredTripSummary.dateBegin = moment(this.formGenerateReport.value.dateBegin).format('YYYY-MM-DD');
        insuredTripSummary.dateEnd = moment(this.formGenerateReport.value.dateEnd).format('YYYY-MM-DD');

        window.open(this.commonService.getServiceUrl(
            `travel-member/summary/${this.policyNumber}?dateBegin=${insuredTripSummary.dateBegin}&dateEnd=${insuredTripSummary.dateEnd}`
        ), '_blank');
    }

    /**
     * @param inputData - policyNumber
     */
    inputData(inputData?: any): void {
        this.policyNumber = inputData;
    }
}
